import { styled } from "@pigment-css/react";
import { OutlinedPillButton } from "@acto/taskpane/field-sales-2/components/primitives/OutlinedPillButton";

const LoadMoreFooter = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: `${theme.fieldSalesTwo.spacing[16]} 0`,
}));

const LoadMoreButton = styled(OutlinedPillButton)(({ theme }) => ({
  padding: `0 ${theme.fieldSalesTwo.spacing[24]}`,
}));

interface TodoLoadMoreFooterProps {
  /** Already translated by the caller. */
  label: string;
  isFetching: boolean;
  onLoadMore: () => void;
}

export function TodoLoadMoreFooter({ label, isFetching, onLoadMore }: TodoLoadMoreFooterProps) {
  return (
    <LoadMoreFooter>
      <LoadMoreButton type="button" onClick={onLoadMore} disabled={isFetching}>
        {label}
      </LoadMoreButton>
    </LoadMoreFooter>
  );
}
